import * as types from './actionTypes'

export function setSlashActiveAction(payload) {
  return {
    type: types.SET_SLASH_ACTIVE,
    payload,
  }
}

export function setItemUnavailable() {
  return { type: types.SET_ITEM_UNAVAILABLE }
}
